// The original dashboard "Quick actions" row (owner decision 3): start segments + Log time. The start
// segments hide while a timer exists; Log time stays. Sprint 15 (§9.3): projectId (the dashboard selection)
// starts the timer on it and pre-fills Start with details; the Dashboard pre-fills Log time.
import { Plus } from 'lucide-react';
import { Kbd } from '@/components/Kbd';
import { SectionTitle } from '@/components/SectionTitle';
import { TimerStartButtons } from '@/components/timer/TimerStartButtons';
import { useTimerActions } from '@/components/timer/TimerActionsProvider';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { useTimer } from '@/hooks/use-timer';
import { SHORTCUT_HINTS } from '@/lib/keyboard-shortcuts';

const LOG_HINT = SHORTCUT_HINTS['log-time'];

export function QuickActions({ onLogTime, projectId }: { onLogTime: () => void; projectId?: string | null }): JSX.Element {
  const actions = useTimerActions();
  const timer = useTimer();
  return (
    <>
      <SectionTitle
        title="Quick actions"
        hint="Start a timer or add work without navigating away — start instantly, start with details, or log past time."
      />
      {timer.isLoading ? (
        <Skeleton className="mb-8 h-10 w-full sm:w-96" />
      ) : (
        <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-center">
          <TimerStartButtons
            variant="inline"
            onStartInstant={() => (projectId ? actions.startWith({ projectId, description: null }) : actions.startInstant())}
            onStartWithDetails={() => (projectId ? actions.openStartWithDetails({ projectId }) : actions.openStartWithDetails())}
          />
          <Button variant="secondary" onClick={onLogTime} aria-keyshortcuts={LOG_HINT.aria} title={`Log time (${LOG_HINT.title})`}>
            <Plus /> Log time <Kbd>{LOG_HINT.label}</Kbd>
          </Button>
        </div>
      )}
    </>
  );
}
